import { Injectable } from '@angular/core';
import { EstadoFilaPontoLocal, RegistroPontoPendente, ResumoRegistroPontoPendente } from './servico-fila-ponto-local';

export interface EstadoFilaOfflineRegistrador {
  registrosPendentesOffline: number;
  resumosFilaOffline: ResumoRegistroPontoPendente[];
  totalPendentesOffline: number;
  totalFalhasOffline: number;
  totalSincronizadosOffline: number;
}

@Injectable({ providedIn: 'root' })
export class ServicoEstadoFilaOfflineRegistrador {
  vazio(): EstadoFilaOfflineRegistrador {
    return {
      registrosPendentesOffline: 0,
      resumosFilaOffline: [],
      totalPendentesOffline: 0,
      totalFalhasOffline: 0,
      totalSincronizadosOffline: 0
    };
  }

  doEstadoLocal(estadoFila: EstadoFilaPontoLocal): EstadoFilaOfflineRegistrador {
    return {
      registrosPendentesOffline: estadoFila.registrosPendentes,
      resumosFilaOffline: estadoFila.resumos,
      totalPendentesOffline: estadoFila.totalPendentes,
      totalFalhasOffline: estadoFila.totalFalhas,
      totalSincronizadosOffline: estadoFila.totalSincronizados
    };
  }

  incluindo(estado: EstadoFilaOfflineRegistrador, registro: RegistroPontoPendente): EstadoFilaOfflineRegistrador {
    const resumo: ResumoRegistroPontoPendente = {
      offlineId: registro.offlineId,
      criadoEm: registro.criadoEm,
      atualizadoEm: registro.atualizadoEm,
      situacao: registro.situacao,
      tentativas: registro.tentativas,
      funcionarioNome: registro.funcionarioNome,
      funcionarioMatricula: registro.funcionarioMatricula,
      ultimaMensagem: registro.ultimaMensagem,
      nsr: registro.nsr,
      dataHoraServidor: registro.dataHoraServidor,
      possuiBiometriaPendente: !!registro.imagemFacialBase64 || !!registro.descritorFacial?.length
    };
    const resumos = [resumo, ...estado.resumosFilaOffline.filter(item => item.offlineId !== resumo.offlineId)];
    return {
      registrosPendentesOffline: resumos.filter(item => item.situacao === 'PENDENTE' || item.situacao === 'FALHA').length,
      resumosFilaOffline: resumos,
      totalPendentesOffline: resumos.filter(item => item.situacao === 'PENDENTE').length,
      totalFalhasOffline: resumos.filter(item => item.situacao === 'FALHA').length,
      totalSincronizadosOffline: resumos.filter(item => item.situacao === 'SINCRONIZADO').length
    };
  }
}
